import { render } from "./CargoDimensionsFormula.vue?vue&type=template&id=aed6658a"
import script from "./CargoDimensionsFormula.vue?vue&type=script&lang=js"
export * from "./CargoDimensionsFormula.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__